import { render, staticRenderFns } from "./infoModel.vue?vue&type=template&id=09ff2132"
import script from "./infoModel.vue?vue&type=script&lang=js"
export * from "./infoModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09ff2132')) {
      api.createRecord('09ff2132', component.options)
    } else {
      api.reload('09ff2132', component.options)
    }
    module.hot.accept("./infoModel.vue?vue&type=template&id=09ff2132", function () {
      api.rerender('09ff2132', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/listManage/infoModel.vue"
export default component.exports